<script lang="ts" setup>
import { useChatStore } from '../stores/chatStore';
import type { FollowupQuestion } from '../utils/type';

const chatStore = useChatStore();

const props = defineProps<{
    isShow: boolean
    questions: FollowupQuestion[]
    language: string
}>();

/**
 * 次の質問を表示する
 */
const isQuestionObject = (question: FollowupQuestion): question is Exclude<FollowupQuestion, string> => {
    return typeof question === 'object' && question !== null && 'value' in question;
};

const nextQuestions = async (question: FollowupQuestion) => {
    if (chatStore.isStreaming) {
        return;
    }

    const isObject = isQuestionObject(question);
    const value = isObject ? question.value : question;
    if (!value || value.trim().length === 0) {
        return;
    }

    const isRetry = isObject && Boolean(question.isRetry);
    chatStore.search(value, null, { isRetry });
};

const getQuestionLabel = (question: FollowupQuestion) => {
    return isQuestionObject(question) ? question.label : question;
};
</script>

<template>
    <div v-if="props.questions.length > 0">
    </div>
    <div v-if="props.isShow && props.questions.length > 0" class="mt-2">
        <template v-for="question in props.questions">
            <button type="button"
                class="bg-white border border-solid border-design-red rounded-2xl px-2 py-1 text-sm max-w-[300px] m-1 hover:bg-design-pink"
                @click="nextQuestions(question)" :disabled="chatStore.isStreaming"
                :class="chatStore.createLanguageClass(props.language)">{{ getQuestionLabel(question) }}
            </button>
        </template>
    </div>
</template>
<style scoped>
button:disabled {
    @apply opacity-60;
    @apply cursor-not-allowed;
}
</style>
